import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormAvatarComponent, FormInputComponent } from '@shared/forms';
import { InstructorFacade } from '@app/store/instructor';

@Component({
    selector: 'app-instructor-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormAvatarComponent, FormInputComponent],
})
export class AddComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly instructorFacade = inject(InstructorFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);

    readonly saving = this.instructorFacade.saving;

    readonly form = this.formBuilder.group({
        firstName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        lastName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        degree: this.formBuilder.control(''),
        university: this.formBuilder.control(''),
        mediaImageId: this.formBuilder.control<string | null>(null),
    });

    constructor() {
        effect(() => {
            if (this.instructorFacade.saved()) {
                this.close();
            }
        });

        effect(() => {
            if (this.instructorFacade.saving() === false && this.instructorFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.instructorFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            const value = this.form.getRawValue();
            this.instructorFacade.createInstructor({
                firstName: value.firstName,
                lastName: value.lastName,
                degree: value.degree || undefined,
                university: value.university || undefined,
                mediaImageId: value.mediaImageId,
            });
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
